import { blue, green, grey, orange } from '@mui/material/colors';

export const chipsStyles = {
	chipsRoot: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'no-wrap',
		gap: 1,
		// Note (Ben): 4x to create equal margin either side so chips can't overflow the card
		maxWidth: 'calc(100% - 4 * var(--mui-spacing))'
	},

	chipRoot: {
		display: 'inline-flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		height: '24px',
		maxWidth: '100%',
		minWidth: 0,
		flexShrink: 0,
		p: 0,
		pl: 1,
		border: 'none',
		letterSpacing: '0.16px',
		lineHeight: '18px',
		fontSize: '13px',
		fontWeight: 400,

		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		gap: 0.5,

		'& .MuiChip-label': {
			pl: 0
		},
		'& .MuiSvgIcon-root': {
			ml: 0
		}
	},

	mobileDeviceRoot: {
		px: 1,
		borderRadius: '999px'
	},

	basicChip: {
		backgroundColor: grey[200],
		color: 'text.primary'
	},

	primaryChip: {
		backgroundColor: orange[50],
		color: orange[800]
	},

	secondaryChip: {
		backgroundColor: orange[50],
		color: orange[800]
	},

	removedChip: {
		height: '24px',
		maxWidth: 'min-content',
		p: 0,
		border: 'none',
		backgroundColor: 'var(--mui-palette-error-main)',
		color: 'white'
	},

	sampleEligibleChipRoot: {
		backgroundColor: blue[50],
		color: 'primary.main'
	},

	expiryDateChipRoot: {
		backgroundColor: green[50],
		color: green[800]
	},

	successChip: {
		backgroundColor: green[50],
		color: green[800]
	},

	icon: {
		width: '14px',
		height: '15px',
		ml: {
			xs: 0,
			md: 1
		}
	},

	indicateError: {
		background: 'var(--mui-palette-error-main)',
		color: 'var(--mui-palette-common-white)'
	},

	dcrStatusChip: {
		border: '1px solid',
		width: 'fit-content',
		'& .MuiChip-label': {
			paddingLeft: 0.75,
			lineHeight: 1
		}
	},

	dcrStatusChipIcon: {
		height: 16,
		width: 16,
		marginLeft: 1,
		fill: 'none'
	}
};
